module.exports = __webpack_public_path__ + "static/media/Bill_M.de6fddb8.jpg";